import styled from 'styled-components';

const BackgroundImage = styled.div`
  background-color: ${({ backgroundColor }) => backgroundColor || 'red'};
  height: ${({ height }) => height || '260px'};
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: -1;

  &::after {
    box-shadow: ${({ backgroundImage }) => {
      return backgroundImage
        ? 'inset 0 -10em 10em rgba(0, 0, 0, 0.5), inset 0 0 0 10em rgba(0, 0, 0, 0.2)'
        : '0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12)';
    }};
    content: '';
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    background-image: ${({ backgroundImage }) =>
      backgroundImage ? `url(${backgroundImage})` : ''};
    background-size: cover;
    background-position: center;
  }
`;

export default BackgroundImage;
